import { makeAsyncAction } from '../../../ui-lottery';
import * as types from '../constants/actions';
import * as api from '../api';

export const fetchOrganizations = makeAsyncAction(
  types.FETCH_ORGANIZATIONS,
  () => () => api.fetchOrganizations(),
  'orgs'
);
